<template>
  <div class="home_systems">
    <section class="main">
      <div class="apps">
        <div v-for="(a, idx) in apps.items" :key="idx" class="app" :style="setAppsStyle(idx)" @click="select(a, idx)"
          :k='idx'>
          <img :src="require('@/assets/images/logo.png')" />
        </div>
      </div>

    </section>
  </div>
</template>
<script>
  const styles = {
    4: [{
      top: "10%",
      marginLeft: "0%",
      opacity: 1,
      width: "25%"
    }, {
      top: "10%",
      marginLeft: "30%",
      opacity: 0.5,
      width: "15%"
    }, {
      top: "5%",
      marginLeft: "0%",
      opacity: 0.3,
      width: "15%"
    }, {
      top: "10%",
      marginLeft: "-30%",
      opacity: 0.5,
      width: "15%"
    }],
    10: [{
      top: "35%",
      marginLeft: "0",
      opacity: 1,
      width: "16%"
    }, {
      top: "32%",
      marginLeft: "24%",
      opacity: .95,
      width: "14%"
    }, {
      top: "24%",
      marginLeft: "40%",
      opacity: .7,
      width: "12%"
    }, {
      top: "19%",
      marginLeft: "26%",
      opacity: .6,
      width: "9%"
    }, {
      top: "17%",
      marginLeft: "12%",
      opacity: .5,
      width: "8.5%"
    }, {
      top: "17%",
      marginLeft: "0",
      opacity: .4,
      width: "8%"
    }, {
      top: "17%",
      marginLeft: "-12%",
      opacity: .5,
      width: "8.5%"
    }, {
      top: "19%",
      marginLeft: "-26%",
      opacity: .6,
      width: "9%"
    }, {
      top: "24%",
      marginLeft: "-40%",
      opacity: .7,
      width: "12%"
    }, {
      top: "32%",
      marginLeft: "-24%",
      opacity: .9,
      width: "14%"
    }]
  };
  export default {
    props: {
      appItems: {
        type: Array,
        default () {
          return []
        }
      }
    },
    data() {
      let appItems = this.appItems;

      return {
        apps: {
          selected: appItems[0],
          transitionDuration: 0.5,
          items: appItems,
          orders: [...Array(appItems.length).keys()],
        }
      }
    },
    computed: {
      appsHalfNr() {
        return Math.ceil(this.apps.items.length / 2);
      },
    },
    watch: {
      appItems: {
        handler: function(val) {
          this.apps.items = val;
          val.forEach(item => {
            if (item.id == this.apps.selected.id) {
              this.apps.selected = item;
            }
          });
        }
      }
    },
    methods: {
      //点击某一个app
      select(app, idx) {
        const order = this.apps.orders[idx];
        this.apps.selected = app;
        const steps = order <= this.appsHalfNr ? -order : (this.apps.items.length - order);
        this.apps.transitionDuration = Math.abs(0.5 / steps);
        this.startAnimation(steps);
        this.$emit('selectApp', app);
      },
      startAnimation(steps) {
        const orders = this.apps.orders.slice();
        const step = steps > 0 ? 1 : -1;
        const app = step > 0 ? orders.shift() : orders.pop();
        if (undefined !== app) {
          step > 0 ? orders.push(app) : orders.unshift(app);
        }
        this.apps.orders = orders;
        const next = steps - step;
        if (next === 0) {
          return;
        }
        setTimeout(() => {
          this.startAnimation(next);
        }, this.apps.transitionDuration * 1000);
      },
      //app样式
      setAppsStyle(idx) {
        var leng = 4;
        var order = this.apps.orders[idx];

        var top = styles[leng][order].top;
        var opacity = styles[leng][order].opacity;
        var marginLeft = styles[leng][order].marginLeft;
        var width = styles[leng][order].width;
        var left = styles[leng][order].left;

        // var boxShadow = styles[leng][order].boxShadow;

        var style = {
          'transition-duration': this.apps.transitionDuration + 's',
          'opacity': opacity,
          'margin-left': marginLeft,
          'width': width,
          // 'height': width,
          'margin-top': top,
          // 'box-shadow:': boxShadow
        };

        if (left) {
          delete style['margin-left'];
          style.left = left;
        }

        return style;
      },
      bankPage(url) {
        var id = 'bank_a';
        var a = null;
        // 防止反复添加
        if (!document.getElementById(id)) {
          a = document.createElement('a');
          a.setAttribute('href', url);
          a.setAttribute('target', '_blank');
          a.setAttribute('id', id);
          document.body.appendChild(a);
        } else {
          a = document.getElementById(id);
          a.setAttribute('href', url);
        }
        a.style.display = "none"
        a.click();
      },
    }
  }
</script>
<style lang="scss" scopde="home_systems">
  .home_systems {
    margin-top: 10%;
    height: 90%;

    .main {
      display: flex;
      justify-content: center;
      background-size: 80%;
      width: 100%;
      height: 100%;
      flex-direction: column;

      .apps {
        flex-grow: 1;
        display: flex;
        justify-content: center;
        position: relative;

        .track {
          margin-top: 5rem;
          width: 26.1875rem;
          height: 5.5625rem;
          // width: 100%;
          // height: 20%
        }

        .app {
          position: absolute;
          cursor: pointer;
          transition-property: all;
          transition-timing-function: linear;
          border-radius: 50%;
          overflow: hidden;
          background: #ccc;

          img {
            width: 100%;

            &.grayscale {
              filter: grayscale(0.9);
            }
          }
        }
      }

      .button {
        align-self: center;
        border: none;
        color: #fff;
        font-size: 1.3rem;
        text-align: center;
        letter-spacing: 1px;
        cursor: pointer;
        border-radius: 2px;
        text-decoration: none;
        position: relative;
        bottom: 10%;
      }
    }
  }
</style>
